import workSchema from '@Entities/schemas/work/work-schema'
import { z } from 'zod'
import { WriterModel } from '@Entities/work/writer-model'
import writerSchema from '@Entities/schemas/work/writer-schema'

const existingWorkSchema = (existingWorkHadComposer: boolean, existingWorkHadWriters = true) =>
    workSchema.extend({
        writers: z.array(writerSchema).superRefine((writers: WriterModel[], ctx) => {
            if (!existingWorkHadWriters && writers.length === 0) {
                return
            }

            if (writers.length === 0) {
                ctx.addIssue({
                    code: 'too_small',
                    minimum: 1,
                    inclusive: true,
                    exact: false,
                    type: 'array',
                    message: 'Work must have at least 1 writer',
                    origin: 'array',
                })
                return
            }

            if (existingWorkHadComposer) {
                const hasComposer = writers.some((writer) => writer.roleCode === 10 || writer.roleCode === 11)
                if (!hasComposer) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        message:
                            'At least one Composer/Author or Composer writer role is required to submit a work registration.',
                        path: [0, 'roleCode'],
                    })
                }
            }
        }),
    })

export default existingWorkSchema
